/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IncentivePlan,
    IncentivePlanFromJSON,
    IncentivePlanFromJSONTyped,
    IncentivePlanToJSON,
} from './IncentivePlan';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';

/**
 * 
 * @export
 * @interface IncentivePlansResponse
 */
export interface IncentivePlansResponse {
    /**
     * 
     * @type {Array<IncentivePlan>}
     * @memberof IncentivePlansResponse
     */
    results: Array<IncentivePlan>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof IncentivePlansResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof IncentivePlansResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof IncentivePlansResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof IncentivePlansResponse
     */
    hasPreviousPage?: boolean;
}

export function IncentivePlansResponseFromJSON(json: any): IncentivePlansResponse {
    return IncentivePlansResponseFromJSONTyped(json, false);
}

export function IncentivePlansResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncentivePlansResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(IncentivePlanFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function IncentivePlansResponseToJSON(value?: IncentivePlansResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(IncentivePlanToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

